import styled, {keyframes} from 'styled-components';
import {dFlexColumn} from '../../../../globalVariables/GlobalFlex';

export const body = styled.div`
    ${dFlexColumn}
    gap: var(--space-lg);
    padding: var(--space-sm) var(--space-xl);
`;

const pinDrop = keyframes`
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const haloPulse = keyframes`
    0% {
        transform: scale(0.5);
        opacity: 0.45;
    }
    70% {
        transform: scale(1.5);
        opacity: 0;
    }
    100% {
        transform: scale(1.5);
        opacity: 0;
    }
`;

export const map = styled.div`
    ${dFlexColumn}
    align-items: center;
    width: 100%;

    svg {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 260px;
        display: block;
    }

    svg [data-mine] {
        cursor: pointer;
    }

    svg [data-stage] {
        fill: var(--primitive-gray-300);
        stroke: var(--primitive-gray-300);
    }

    /* the seat pin marks, it never captures — taps land on the block underneath and zoom in */
    svg [data-seat-pin] {
        pointer-events: none;
    }

    svg [data-pin-drop] {
        animation: ${pinDrop} 0.55s cubic-bezier(0.34, 1.56, 0.64, 1) 0.3s backwards;
        filter: drop-shadow(0 1.5px 1.5px rgb(0 0 0 / 0.35));
    }

    svg [data-pin-halo] {
        fill: #e0384c;
        transform-box: fill-box;
        transform-origin: center;
        animation: ${haloPulse} 2s ease-out 0.85s infinite backwards;
    }
`;
